<template>
    <div class="container min-full">
        <button class="back" @click="refreshAssessments()"><svg-icon icon="refresh" width="32" /></button>
        <h1 class="mb-5">{{ $t('myAssessments') }}</h1>
        <LoadingSpinner v-if="loading" />
        <template v-else>
            <b-list-group class="flex-row flex-wrap">
                <AssessmentBlock :assessment="assessment" v-for="assessment in assessments" :key="assessment.id"/>
            </b-list-group>
            <p v-if="loadError" class="text-center">{{ $t(loadError) }}</p>
            <p v-else-if="assessments.length === 0" class="text-center">{{ $t('noAssessments') }}</p>
        </template>
    </div>
</template>
<script>
import SvgIcon from '@/components/SvgIcon'
import AssessmentService from '../services/AssessmentService';
import AssessmentBlock from '../components/AssessmentBlock';
import LoadingSpinner from '@/components/loader/Loader';
import { sites } from 'sites-config';
import { isAuthExpiredError } from '@/common/auth';
import { getListNetworkErrorMessage, notifyError } from '@/common/network';

export default {
    name: 'AssessmentsScreen',
    components: {
        AssessmentBlock,
        LoadingSpinner,
        SvgIcon
    },
    data() {
        return {
            assessments: [],
            loading: true,
            loadError: null,
        }
    },
    mounted(){
        this.getAssessments();
    },
    methods: {
        refreshAssessments() {
            this.loading = true;
            this.getAssessments();
        },
        async getAssessments() {
            this.assessments = [];
            try {
                this.loadError = null;
                const response = await AssessmentService.getAssessments();
                if (this.$store.state.site.id === 0) {
                    const excludedProviderIds = Object.values(sites).map(site => site.id);
                    response.assessments = response.assessments.filter(
                        a => !excludedProviderIds.includes(a.provider_id)
                    );
                } else {
                    response.assessments = response.assessments.filter(
                        a => a.provider_id === this.$store.state.site.id
                    );
                }
                this.assessments = response.assessments;
                this.loading = false;
            } catch (error) {
                this.loading = false;
                if (isAuthExpiredError(error)) {
                    return;
                }
                notifyError(error, {
                    source: {
                        screen: 'AssessmentsScreen',
                        action: 'getAssessments',
                    },
                });
                this.assessments = [];
                this.loadError = getListNetworkErrorMessage('assessments');
            }
        }
    }
}
</script>
